module.exports = __webpack_public_path__ + "static/WEDDING E&M-402-f9ed306f7e7b07d536dad3de9eccaf96.jpg";